// const baseUrl='http://192.168.18.7:8080/api' 
// const baseUrl='http://localhost:8080/api' 
// const baseUrl="http://192.168.18.7:8080/api"
// const baseUrl="http://lazy-days-push.loca.lt/api"
const baseUrl="https://cethostel.in/api"
// const baseUrl='http://3.109.84.20/api'  

export {baseUrl}